<template>
  <Header
      v-if="$route.name !== 'MyCourses' && $route.name !== 'Lesson' && $route.name !== 'Course' && $route.name !== 'Category' && $route.name !== 'Categories' && $route.name !== 'Dashboard' && $route.name !== 'CompanyProfile' && $route.name !== 'Admin' && $route.name !== 'GVLearning' && $route.name !== 'Store'"/>
  <router-view/>
  <Footer
      v-if="$route.name !== 'MyCourses' && $route.name !== 'Lesson' && $route.name !== 'Course' && $route.name !== 'Category' && $route.name !== 'Categories' && $route.name !== 'Dashboard' && $route.name !== 'CompanyProfile' && $route.name !== 'Store' && $route.name !== 'GVBusiness' && $route.name !== 'Admin' && $route.name !== 'Login'&& $route.name !== 'GVLearning' && $route.name !== 'MembershipRegistration' && $route.name !== 'BusinessesRegistration'"/>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from "@/components/Footer";

export default {
  components: {
    Footer,
    Header
  }
}
</script>
